var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { getChildrenByType } from 'react-nanny';
import { Footnote, Header, HeaderLarge, HeaderExtraLarge, SegmentBarWrapper as Component } from './ProgressBar.styled';
import { small as smallCss } from '../styles/legacy';
import { small as smallCssCitrus2022 } from '../styles/citron';
import { renderSection } from './private/_utils';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { iif, isNotNullOrEmpty } from '@pcty/utils';
import { useTheme } from '@citrus/user';
var VERSION = '4.6.0';
var ProgressBarSegments = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var automationId = _a.automationId, caption = _a.caption, children = _a.children, className = _a.className, css = _a.css, _d = _a.extraLargeText, extraLargeText = _d === void 0 ? false : _d, hidden = _a.hidden, _e = _a.hideLabels, hideLabels = _e === void 0 ? false : _e, _f = _a.hideTooltips, hideTooltips = _f === void 0 ? false : _f, _g = _a.largeText, largeText = _g === void 0 ? false : _g, 
    // FIXME: check if `progress` is needed
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    progress = _a.progress, renderFootnote = _a.renderFootnote, renderHeader = _a.renderHeader, _h = _a.small, small = _h === void 0 ? false : _h, 
    // FIXME: check if `warning` is needed
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _j = _a.warning, 
    // FIXME: check if `warning` is needed
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    warning = _j === void 0 ? false : _j, _k = _a.__TYPE, TYPE = _k === void 0 ? 'ProgressBarSegments' : _k, other = __rest(_a, ["automationId", "caption", "children", "className", "css", "extraLargeText", "hidden", "hideLabels", "hideTooltips", "largeText", "progress", "renderFootnote", "renderHeader", "small", "warning", "__TYPE"]);
    var debug = useCitrusDebug();
    var isCitron = useTheme().citrus2022;
    if (hidden)
        return null;
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNullOrEmpty(css),
        _b), className || '');
    var emotionObj = (_c = {},
        _c[emotionCss(isCitron ? smallCssCitrus2022 : smallCss)] = small,
        _c);
    var barWrapperClasses = cx(emotionObj, 'progress-bar-segment-container', className || '');
    var header = iif(extraLargeText, HeaderExtraLarge, iif(largeText, HeaderLarge, Header));
    return (React.createElement(Component, __assign({ className: classes, ref: ref }, other, getAutomation(automationId), getDebug(debug, TYPE, VERSION)),
        renderSection(renderHeader, header, getAutomation(automationId, 'header'), caption),
        React.createElement("div", { className: barWrapperClasses, style: { width: '100%' } },
            getChildrenByType(children, ['Segment']).map(function (x, index, _a) {
                var length = _a.length;
                return React.cloneElement(x, {
                    small: small,
                    __hideLabels: hideLabels,
                    __hideTooltips: hideTooltips,
                    __first: index === 0,
                    __last: length - 1 === index,
                });
            }),
            getChildrenByType(children, ['SegmentLegend']).map(function (x, index, _a) {
                var length = _a.length;
                return React.cloneElement(x, {
                    small: small,
                    __first: index === 0,
                    __last: length - 1 === index,
                    __count: length,
                });
            })),
        renderSection(renderFootnote, Footnote, getAutomation(automationId, 'footnote'))));
});
ProgressBarSegments.defaultProps = {
    __TYPE: 'ProgressBarSegments',
};
export default ProgressBarSegments;
